module.exports = {
	en: {
		'checkin.title': 'Match Check In',
		'checkin.body':
			'Please select {rosterMinSize} players and tap the START WAR button to check-in to your match to confirm that your team is ready to play',
		'checkin.bodyMonthlyFinal':
			'Please tap the START WAR button to check-in to your match to confirm that your team is ready to play',
	},
	fr: {
		'checkin.title': 'Enregistrement du match',
		'checkin.body':
			'Choisissez {rosterMinSize} joueurs et appuyez sur DÉCLARER LA GUERRE pour vous enregistrer à votre match et confirmer que votre équipe est prête',
	},
	it: {
		'checkin.title': 'Registrazione allo scontro',
		'checkin.body':
			'Scegli {rosterMinSize} giocatori e seleziona "AVVIA GUERRA" per effettuare la registrazione per lo scontro e confermare che la squadra è pronta a giocare.',
	},
	de: {
		'checkin.title': 'Match-Check-in',
		'checkin.body':
			'Bitte wähle {rosterMinSize} Spieler aus und tippe auf „KRIEG STARTEN“, um den Check-in für dein Match abzuschließen und zu bestätigen, dass dein Team bereit zum Spielen ist.',
	},
	es: {
		'checkin.title': 'Registro en el partido',
		'checkin.body':
			'Elige a {rosterMinSize} jugadores y toca «Iniciar guerra» para registrarte en tu partido y confirmar que tu equipo está listo para jugar.',
	},
	pt: {
		'checkin.title': 'Check-in da disputa',
		'checkin.body':
			'Selecione {rosterMinSize} jogadores e toque no botão INICIAR GUERRA para fazer o check-in na disputa e confirmar a disponibilidade da sua equipe.',
	},
	jp: {
		'checkin.title': 'マッチにチェックイン',
		'checkin.body':
			'チームの準備が整ったら、{rosterMinSize}名のプレイヤーを選択して「対戦開始」ボタンをタップし、マッチへのチェックインを完了してください。',
	},
	ko: {
		'checkin.title': '매치 출석 확인',
		'checkin.body':
			"{rosterMinSize}명의 선수를 선택하고 '전쟁 시작' 버튼을 탭해 매치 출석을 확인함으로써 팀이 플레이할 준비가 되었음을 확정하세요.",
	},
	zh_TW: {
		'checkin.title': '比賽報到',
		'checkin.body':
			'請選擇{rosterMinSize}名選手並點擊「開始對戰」完成比賽報到程序，以確認你的隊伍已準備就緒，可以開始比賽。',
	},
}
